import React, { useEffect } from 'react';
import Hero from './Hero';
import About from './About';
import Projects from './Projects';
import SkillsDashboard from './SkillsDashboard';
import Career from './Career';
import Contact from './Contact';

function PortfolioContent() {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('revealed');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
        );

        document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <>
            <Hero />
            <About />
            <Career />
            <SkillsDashboard />
            <Projects />
            <Contact />
        </>
    );
}

export default PortfolioContent;